import type { MenuGroup } from '@/core/layout/menuConfig';
import { adminMenu } from '@/core/layout/menuConfig';

const ALL_MENU_GROUPS: MenuGroup[][] = [adminMenu];

export function resolvePageTitle(pathname: string): string | null {
  const normalized = pathname.replace(/\/$/, '') || '/';
  let best: { path: string; title: string } | null = null;

  for (const menus of ALL_MENU_GROUPS) {
    for (const group of menus) {
      for (const section of group.Items) {
        if (section.path && matchesPath(normalized, section.path)) {
          if (!best || section.path.length > best.path.length) {
            best = { path: section.path, title: section.title };
          }
        }
        for (const child of section.children ?? []) {
          if (matchesPath(normalized, child.path)) {
            if (!best || child.path.length > best.path.length) {
              best = { path: child.path, title: child.title };
            }
          }
        }
      }
    }
  }

  return best?.title ?? null;
}

function matchesPath(pathname: string, menuPath: string): boolean {
  return pathname === menuPath || pathname.startsWith(`${menuPath}/`);
}

const EXTRA_TITLES: Record<string, string> = {
  '/account': 'My Profile',
  '/admin/users': 'Leader logins',
  '/admin/organizations': 'Churches',
  '/admin/members': 'Members',
  '/admin/members/import': 'Import members',
  '/admin/units': 'Unit',
  '/admin/zonal': 'Zonal',
  '/admin/departments': 'Departments',
  '/admin/calendar': 'Church calendar',
  '/admin/calendar/import': 'Import calendar',
  '/admin/events': 'Events',
  '/admin/assets': 'Assets',
  '/admin/assets/import': 'Import assets',
  '/admin/expenses': 'Expenses',
  '/admin/expenses/import': 'Import expenses',
  '/admin/giving': 'Giving',
  '/admin/communications': 'Communications',
  '/admin/settings/locations': 'Local locations',
  '/admin/settings/countries': 'International',
  '/admin/settings/currencies': 'Currencies',
  '/admin/settings/languages': 'Languages',
  '/admin/settings/communication-providers': 'Communication providers',
};

export function resolvePageVisitMessage(pathname: string): string | null {
  const normalized = pathname.replace(/\/$/, '') || '/';
  for (const [path, title] of Object.entries(EXTRA_TITLES)) {
    if (matchesPath(normalized, path)) return title;
  }
  return resolvePageTitle(pathname);
}
